<template>
  <div class="advanced-config">
    <ConfigSection title="高级设置" icon="⚙️">
      <div class="form-group">
        <label class="form-label">打印模式</label>
        <select v-model="printMode" class="form-control">
          <option value="single">单页打印</option>
          <option value="continuous">连续打印</option>
          <option value="batch">批量打印</option>
        </select>
      </div>
      
      <div class="form-group">
        <label class="form-label">数据源</label>
        <select v-model="dataSource" class="form-control">
          <option value="static">静态数据</option>
          <option value="api">API接口</option>
          <option value="file">文件导入</option>
        </select>
      </div>
    </ConfigSection>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
import ConfigSection from './ConfigSection.vue'

export default {
  name: 'AdvancedConfig',
  components: {
    ConfigSection
  },
  
  setup() {
    const store = useStore()
    
    const printMode = computed({
      get: () => store.state.template.config.printMode || 'single',
      set: (value) => store.dispatch('template/updateConfig', { key: 'printMode', value })
    })
    
    const dataSource = computed({
      get: () => store.state.template.config.dataSource || 'static',
      set: (value) => store.dispatch('template/updateConfig', { key: 'dataSource', value })
    })
    
    return {
      printMode,
      dataSource
    }
  }
}
</script>

<style scoped>
.form-group {
  margin-bottom: 16px;
}

.form-label {
  display: block;
  margin-bottom: 6px;
  font-weight: 500;
  color: #495057;
  font-size: 14px;
}

.form-control {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ced4da;
  border-radius: 6px;
  font-size: 14px;
}
</style>
